import styled from 'styled-components';

export const ContentMaker = styled.div`
white-space: pre-line;
`;
